import { setPageTitle } from "@/utils";
import Vue from "vue";
import VueRouter from "vue-router";
// import { zh_init } from "@/utils/zh.js";
Vue.use(VueRouter);

let routes: any[] = [];
function importAll(r: any) {
  r.keys().forEach((key: string) => {
    routes = routes.concat(r(key).default);
  });
}

importAll(require.context("./routes/", true, /\.ts$/));

const router = new VueRouter({
  scrollBehavior(to, from, savedPosition) {
    //to top

    return { x: 0, y: 0 };
  },
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/",
      name: "课程预告",
      component: () => import("@/views/Layout.vue"),
      children: routes
    },
    {
      path: "*",
      redirect: { path: "/" }
    }
  ]
});
router.beforeEach((to, from, next) => {
  //to and from are Route Object,next() must be called to resolve the hook}
  // document.title = "集盒商学官网-" + (to.meta && to.meta.title);
  // zh_init();
  next();
});
router.afterEach((to, from) => {
  Vue.nextTick(() => {
    // window.$zh_tran(window.$getCookie("zh_choose"));
    // window.$zh_init();
  });
});
export default router;
